
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/university",
      function () {
        return require("private-next-pages/compare/university.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/university"])
      });
    }
  